import { type ComponentProps, createContext } from "react";
import { type MessageVariants, messageVariants } from "./variants";

export const MessageContext = createContext<{
  type: NonNullable<MessageVariants["type"]>;
}>({
  type: "info",
});

export function Message({
  type = "info",
  className,
  ...props
}: ComponentProps<"div"> & MessageVariants) {
  return (
    <MessageContext.Provider value={{ type: type ?? "info" }}>
      <div {...props} className={messageVariants({ type, className })} />
    </MessageContext.Provider>
  );
}
